export const isReversedItem = ({ params, defaultProps }) => {
  const position = params.position || defaultProps.position
  const stacked = params.stacked || defaultProps.stacked

  return position.includes('bottom') || stacked
}
